module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vfcarm2-0d537f182c209ee44203d55eb9340a87.jpg";